"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContextHook = void 0;
const react_1 = __importDefault(require("react"));
const EMPTY = Symbol('__EMPTY__');
exports.createContextHook = (useHook, errorMsg = 'Hook must be wrapped with <Provider/>') => {
    const Context = react_1.default.createContext(EMPTY);
    const Provider = ({ params, children }) => {
        const value = useHook(params);
        return react_1.default.createElement(Context.Provider, { value: value }, children);
    };
    const useContextHook = () => {
        const value = react_1.default.useContext(Context);
        if (value === EMPTY)
            throw new Error(errorMsg);
        return value;
    };
    return [useContextHook, Provider];
};
//# sourceMappingURL=createContextHook.js.map